export const buildAdditionalNotesForm = () => {
  return {
    additionalNotes: ''
  }
}
